export default __webpack_public_path__ + "static/media/015-Iron Man.e98dea62.svg";